export const FoxMark = ({ className = "w-10 h-10", stroke = "currentColor" }) => (
  <svg
    viewBox="0 0 120 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M10 15 L30 55 L60 72 L90 55 L110 15 L85 30 L60 20 L35 30 Z"
      stroke={stroke}
      strokeWidth="2.5"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M30 55 L60 35 L90 55"
      stroke={stroke}
      strokeWidth="2.5"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M60 35 L60 72"
      stroke={stroke}
      strokeWidth="2.5"
      fill="none"
    />
  </svg>
);

export default FoxMark;
